module.exports = __webpack_public_path__ + "static/media/package_img.50c1919b.jpg";